// extracted by mini-css-extract-plugin
export var container = "_dj-0";
export var icon = "_dj-1";
export var text = "_dj-2";